import { ProductOption } from "./ProductOption.js";

export const restrictedProductOptions: ProductOption[] = [ProductOption.CustomerRequirement, ProductOption.Figurines];
